import { lazy } from "react";
import LoginLayout from "./layouts/LoginLayout";
import DashBoardLayOut from "../src/layouts/DashBoardLayOut/index.js";

export const routes = [
  // {
  //   exact: true,
  //   auth: false,
  //   path: "/testComponent",
  //   layout: DashBoardLayOut,
  //   component: lazy(() =>
  //     import("./views/pages/Dashboard/DoctorManagement/test.jsx")
  //   ),
  // },
  {
    exact: true,
    auth: false,
    path: "/",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/Login.jsx")),
  },
  {
    exact: true,
    auth: false,
    path: "/forgot",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/ForgotPassword.jsx")),
  },
  {
    exact: true,
    auth: false,
    path: "/otpVerification",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/OTPVerification.jsx")),
  },
  {
    exact: true,
    auth: false,
    path: "/resetPassword",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/ResetPassword.jsx")),
  },
  {
    exact: true,
    auth: true,
    path: "/dashboard",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DashboardMain/LandingPage.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/notifications",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DashboardMain/NotificationPage.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/profile",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/MyAccountManagement/AccountProfilePage.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/profile/editProfile",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/MyAccountManagement/EditProfile.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/profile/changePassword",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/MyAccountManagement/ChangePassword.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/doctorlisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DoctorManagement/DoctorsListing")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/doctorlisting/employerDetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DoctorManagement/DoctorDetails")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/doctorlisting/viewrequests",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DoctorManagement/ViewRequests")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/doctorlisting/viewrequests/doctorrequestdetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DoctorManagement/DoctorRequestDetails")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/patientlisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/PatientManagement/PatientListing")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/patientlisting/patientdetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/PatientManagement/PatientDetails")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/appointementlisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/AppointmentManagement/AppointmentListing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/marketplacelisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/MarketPlaceManagement/MarketPlaceLististing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/marketplacedetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/MarketPlaceManagement/MarketPlaceDetails.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/patientlisting/UserEventListing",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/UserEventListing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/EventsListing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting/eventdetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/EventDetails.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting/leaderboard",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/LeaderBoard.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting/addEvent",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/CreateUpdateEvent.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting/viewrequests",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/ViewRequests.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/eventlisting/viewrequests/eventrequestsdetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/EventManagement/EventRequestsDetails.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/appointementdetails",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/AppointmentManagement/AppointmentDetails.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/transactionListing",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/TransactionManagement/TransactionListing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/prescriptionlisting",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/PrescriptionManagement/PrescriptionListing.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/prescriptionhistory",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/PrescriptionManagement/PrescriptionHistory.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/StaticContentListing.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/privacyPolicy",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/PrivacyPolicy/PrivacyPolicy.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/editPrivacyPolicy",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/PrivacyPolicy/EditPrivacyPolicy.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/aboutUs",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/AboutUs/AboutUs.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/editAboutUs",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/AboutUs/EditAboutUs.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/termsAndConditions",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/TermsAndCondition/TermsAndConditions.jsx"
      )
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/staticContentListing/editTermsConditions",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import(
        "./views/pages/Dashboard/StaticContentManagement/TermsAndCondition/EditTermsConditions.jsx"
      )
    ),
  },
  { exact: true, path: "*", layout: LoginLayout, component: lazy(() => import("./views/pages/Auth/PageNotFound.jsx")) },
];
